module.exports = __webpack_public_path__ + "static/media/last-hand-bg.afe637a2.svg";